import React, { useState, useEffect, useRef } from 'react';
import { OpenPersonalInfoCard } from './PersonalInfoCard';
import axios from 'axios';
import SignatureCanvas from "react-signature-canvas";
import * as securityHelper from "../../helper/SecurityHelper";
import {fn_loginHandlerCallback} from "../../api/FnCmmn";
import { requestPcc, REAL_NAME_AUTH, onlyDigits } from "../../helper/PccHelper";
import PccRequestForm from "../PccRequestForm";
import {useNavigate} from "react-router-dom";

export default function FirstInfo({ auth, setAuth, authCode, setAuthCode, tabMoving, setTabMoving, setSnackbarTxt, signature, setSignature, outputRef, tab, setTab, notWok, setNotWok, sentSms, setSentSms, isPhnCnfrmd, setIsPhnCnfrmd, setPhoneNum, setUserName, password, setPassword, birth, setBirth, sex, setSex, check1, setCheck1, check2, setCheck2, check3, setCheck3, phoneNum, userName, setTerms1, setTerms2, setTerms3, cfrmChk, setCfrmChk, loginProcess, setLoginProcess, realNameCnfrmd, setRealNameCnfrmd }: any) {
  const navigate = useNavigate();
  const [circleCheck, setCircleCheck] = useState(false);
  const [authNum, setAuthNum] = useState('');
  const [pwCheck, setPwCheck] = useState('');
  const celPhnRef = useRef<any>();
  const userNmRef = useRef<any>();
  const pccFormRef = useRef<HTMLFormElement>(null);
  const mouseDownRef = useRef<any>();
  const [exampleHide, setExampleHide] = useState(false);
  const signCanvas = useRef(null) as React.MutableRefObject<any>;
  const [loginAuth, setLoginAuth] = useState(false);
  const [lockoutAuth, setLockoutAuth] = useState(false);

  const personalInfoAllCheck = () => {
    // setTerms1(true);
    // setIsAll(true);
    setCheck1(true);
    setCheck2(true);
    setCheck3(true);
    setCircleCheck(true);
  };
  const personalInfoAllCancle = () => {
    setCircleCheck(false);
    setCheck1(false);
    setCheck2(false);
    setCheck3(false);
  };

  useEffect(() => {
    if (check1 && check2 && check3) {
      setCircleCheck(true);
    };
    if (!check1 || !check2 || !check3) {
      setCircleCheck(false);
    };
  }, [check1, check2, check3]);
  useEffect(() => {
    if(circleCheck) { setCheck1(true); setCheck2(true); setCheck3(true); }
  }, [circleCheck])

  const fn_clear = () => {
    !tabMoving && signCanvas.current.clear();
  }

  const clear = () => {
    setTabMoving(false);
    setSignature('');
    setExampleHide(false);
    fn_clear();
  }

  useEffect(() => {
    const handler = (e: any) => {
      if (mouseDownRef.current && mouseDownRef.current.contains(e.target)) {
        setExampleHide(true);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  });

  const fn_setPhoneNum = (e: any) => {
    let firstChar = e.target.value.substr(0,1);
    let userPhone = e.target.value.replaceAll('-', '');
    const regex = /^[0-9]{12}$/;
    const regexNotNum = /\D/;
    if(!regexNotNum.test(firstChar)) {
      if(!regexNotNum.test(userPhone)){
        if (!regex.test(userPhone)) {
          setPhoneNum(e.target.value.replace(/[^0-9]/g, '')
              .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
              .replace(/(\-{1,2})$/g, ""))
        }
      }
    } else {
      setPhoneNum(e.target.value)
    }
  }
  const triggerLockoutSms = async (userPhone: string) => {
    const res = await axios.post('admin/api/cmmn/smsSend', { to: userPhone });
    if (res.data === 'LIMIT_EXCEEDED') {
      setSnackbarTxt('문자 발송 한도를 초과했습니다.\n잠시 후 다시 시도하거나 고객센터에 문의해주세요.');
      return;
    }
    setAuthNum(res.data.toString());
    setNotWok(false);
    setIsPhnCnfrmd(false);
    setAuthCode('');
    setSentSms(true);
    setLockoutAuth(true);
  }

  const handleLoginResult = async (user: any, userPhone: string, onSuccess: (u: any) => Promise<void>) => {
    if (user && !user.loginFail) {
      await onSuccess(user);
      return;
    }
    alert(user?.loginMessage || '비밀번호가 일치하지 않습니다.');
    if (user?.smsRequired && !lockoutAuth) { await triggerLockoutSms(userPhone); }
  }

  const loginCheckHandler = async () => {
    let userPhone = phoneNum.replaceAll('-', '');
    if(!userPhone) {
      setSnackbarTxt('휴대폰 번호를 입력해주세요.')
      return;
    }
    const regexNotNum = /\D/;
    // const regex = /^[0-9]{11}$/;
    //
    // if(!regexNotNum.test(userPhone)){
    //     if (!regex.test(userPhone)) {
    //         setSnackbarTxt('휴대폰 번호(11자리)를 바르게 입력해주세요.')
    //         return;
    //     }
    // }
    let rtrnData = await axios.post('admin/api/user/retrieveUserPhnDataCnt', { userPhonNum: userPhone });
    if (rtrnData.data.length > 1) {
      setSnackbarTxt('해당 번호로 아이디가 2개 이상 존재합니다.\n관리자에게 문의해주세요.')
      return;
    } else if (rtrnData.data.length === 0) {
      if(regexNotNum.test(userPhone)){
        setSnackbarTxt('존재하지 않는 아이디입니다.\n아이디를 다시 입력해주세요.')
        return;
      }
      setSentSms(false);
      setAuthCode('');
      setLoginProcess(false);
      return;
    } else {
      let userAuth = rtrnData.data[0].authSeq
      let authStr = userAuth === 1 ? 'KOX' : userAuth === 2 ? 'COM' : userAuth === 3 ? 'SRV' : 'WOK'
      if (userAuth !== 4 && !notWok) { setNotWok(true); setIsPhnCnfrmd(true); return; }
      const encryptedPhone = await axios.post('admin/api/cmmn/encryptedPhone', {phone: userPhone});
      let saveUserId = sessionStorage.getItem("SAVE_USER_ID");
      if (userAuth === 4 && saveUserId !== encryptedPhone.data) { // sessionStorage "SAVE_USER_ID" 값이랑 전화번호 같은지 체크
        rtrnData = await axios.post('admin/api/cmmn/smsSend', {to: userPhone});
        setAuthNum(rtrnData.data.toString());
        setSentSms(true);
        setLoginAuth(true);
      } else {
        securityHelper.login(userPhone, authStr, password, async (user: any) => {
          await handleLoginResult(user, userPhone, async (u: any) => {
            await fn_loginHandlerCallback(u, navigate);
          });
        });
      }
    }
  }
  const phoneConfirmHandler = async () => {
    if(!isPhnCnfrmd) {
      if (authCode === '') {
        setSnackbarTxt('인증번호가 잘못되었습니다.\n다시 입력해주세요.');
        return;
      } else if (authCode !== authNum) {
        setSnackbarTxt('인증번호가 잘못되었습니다.\n다시 입력해주세요.')
        return;
      }
      if (lockoutAuth) {
        let userPhone = phoneNum.replaceAll('-', '');
        await axios.post('admin/api/user/resetLoginFail', { phoneOrUserId: userPhone });
        setLockoutAuth(false);
        setSentSms(false);
        setIsPhnCnfrmd(false);
        setAuthCode('');
        setNotWok(true); // 비밀번호 입력창 노출
        alert('문자 인증이 완료되었습니다.\n비밀번호를 다시 입력해주세요.');
        return;
      }
      setIsPhnCnfrmd(true);
    }
    if (loginAuth) {
      let userPhone = phoneNum.replaceAll('-', '');
      const encryptedPhone = await axios.post('admin/api/cmmn/encryptedPhone', {phone: userPhone});
      sessionStorage.setItem("SAVE_USER_ID", encryptedPhone.data);
      securityHelper.login(userPhone, 'WOK', password, async (user: any) => {
        await handleLoginResult(user, userPhone, async (u: any) => {
          await fn_loginHandlerCallback(u, navigate);
        });
      });
    }
    setLoginProcess(false);
  }
  const fn_requestPcc = () => {
    requestPcc(pccFormRef.current, { onError: setSnackbarTxt, onResult: fn_applyPccResult });
  }

  const fn_applyPccResult = (r: any) => {
    if (!r || !r.phone) {
      setSnackbarTxt('실명인증에 실패했습니다.\n다시 시도해주세요.');
      setRealNameCnfrmd(false);
      return;
    }
    if (onlyDigits(r.phone) !== onlyDigits(phoneNum)) {
      setSnackbarTxt('가입하려는 휴대폰 번호와 실명인증한 번호가 다릅니다.\n본인 명의의 휴대폰으로 인증해주세요.');
      setRealNameCnfrmd(false);
      return;
    }
    setUserName(r.name);
    if (r.birthday) { setBirth(r.birthday); }
    if (r.sex) { setSex(r.sex === 'M' ? 'male' : 'female'); }
    setRealNameCnfrmd(true);
    setIsPhnCnfrmd(true);
    setSnackbarTxt('실명인증이 완료되었습니다.');
  }

  const selectAuth = async (selected:string) => {
    if (selected !== auth) { setRealNameCnfrmd(false); }
    setAuth(selected);
    if (selected === REAL_NAME_AUTH) {
      setTab(tab+1);
      return;
    }
    const userPhone = phoneNum.replaceAll('-', '');
    const rtrnData = await axios.post('admin/api/cmmn/smsSend', {to: userPhone});
    if (rtrnData.data === 'LIMIT_EXCEEDED') {
      setSnackbarTxt('문자 발송 한도를 초과했습니다.\n잠시 후 다시 시도하거나 고객센터에 문의해주세요.');
      return;
    }
    setAuthNum(rtrnData.data.toString());
    setAuthCode('');
    setSentSms(true);
  }

  const signUpPhoneConfirmHandler = () => {
    if (authCode === '' || authCode !== authNum) {
      setSnackbarTxt('인증번호가 잘못되었습니다.\n다시 입력해주세요.');
      return;
    }
    setIsPhnCnfrmd(true);
    setSentSms(false);
    setTab(1);
  }
  const saveSignature = () => {
    setSignature(signCanvas.current.toDataURL("image/webp"));
  }
  const fn_nextTab = () => {
    if (tab === 1 && auth === REAL_NAME_AUTH && !realNameCnfrmd) {
      setSnackbarTxt('현장대리인은 실명인증이 필요합니다.');
      return;
    }
    if(tab === 1 && userName === '') {
      setSnackbarTxt('이름을 입력해 주세요.');
      return;
    }
    if (tab === 1 && auth !== 'WOK' && password === '') {
      setSnackbarTxt('비밀번호를 입력해 주세요.');
      return;
    }
    // 비밀번호 규칙 추가
    // let reg = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/;
    // if(tab === 1 && auth !== 'WOK' && !(reg.test(password))){
    //   setSnackbarTxt('비밀번호는 숫자,영어,특수문자를 포함한 8자 이상으로 설정해 주세요.');
    //   return;
    // }
    if (tab === 1 && auth !== 'WOK' && pwCheck === '') {
      setSnackbarTxt('비밀번호 확인을 입력해 주세요.');
      return;
    }
    if (tab === 1 && auth !== 'WOK' && password !== pwCheck) {
      setSnackbarTxt('비밀번호가 일치하지 않습니다.');
      return;
    }
    if (tab === 2) {
      if (!circleCheck) { setCircleCheck(true) }
    }
    if (tab === 3 && (!signature ||
        signature === 'data:image/webp;base64,UklGRjYDAABXRUJQVlA4WAoAAAAgAAAALwIAGQEASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDggSAEAABAlAJ0BKjACGgE+bTaZSaQjIqEgCACADYlpbuF3YRtACewD32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+sAAP7/6NAAAAAAAAAAAAAAAAAAAAAAAAA='
    )) {
      setSnackbarTxt('사각형 안에 서명해 주세요.');
      return;
    }
    if (tab === 3 && signature) { setTabMoving(true); }
    setTab(tab+1)
  }

  return (
    <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-174px)] md:h-[calc(100%-435px)]'>
      <div className={`${(tab === 0 || tab === 1) ? 'sm:w-[75%]' : 'sm:w-[87%]' } w-[255px] md:w-[750px] mb-20 md:mb-[50px]`}>
        {loginProcess && tab === 0 &&<>
          <p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-50 md:mt-[90px]'>{!notWok ? '휴대폰 번호를 입력하세요.' : '비밀번호를 입력하세요.' }</p>
          {(!sentSms && !isPhnCnfrmd) && <p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-15 md:mt-[30px]'>(예) 01012345678</p> }
          <input disabled={sentSms || isPhnCnfrmd} ref={celPhnRef} value={phoneNum} onChange={(e) => fn_setPhoneNum(e)} className='w-full mt-25 md:mt-[50px] py-[0.5rem] md:py-[30px] pl-5 md:pl-[12px] outline-none rounded-[5px] md:rounded-[12px] border border-[0.5px] border-[#a8a8a8]' type='text' />
          {(!sentSms && !isPhnCnfrmd) && <p className='text-14 md:text-37 leading-[18px] md:leading-[45px] mt-15 md:mt-[30px] text-blue-500'>* 회원가입의 경우, 가입할 핸드폰번호를 입력해주세요.</p> }
          {notWok && <input value={password} onChange={(e) => setPassword(e.target.value)} className='mt-20 md:mt-[50px] w-full h-47 md:h-[110px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight' type='password' />}
          {(notWok || (!sentSms && !isPhnCnfrmd)) && <button onClick={loginCheckHandler} className='text-white mt-20 md:mt-[50px] text-19 md:text-40 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo'>다 음</button> }
          {notWok && <button className='text-white text-19 md:text-40 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] mt-15 md:mt-[50px] bg-[#585959]'
                             onClick={() => navigate('/findPw')}>비밀번호 찾기</button>}
          {sentSms && !isPhnCnfrmd && <div className='flex justify-between items-center'>
            <p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-10 md:mt-[30px]'>인증번호 입력</p>
            <input value={authCode} onChange={(e) => setAuthCode(e.target.value)} className='mt-10 md:mt-[30px] w-[60%] h-43 md:h-[107px] pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#a8a8a8] placeholder:text-[#9C9C9B] placeholder:text-17 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25 placeholder:font-preLight' type='number' placeholder="(예) 1234"
                   maxLength={4} onInput={(e:any) => {e.target.value.length > e.target.maxLength && (e.target.value = e.target.value.slice(0, e.target.maxLength)); }}/>
          </div>}
          {(sentSms || tabMoving) && <button onClick={phoneConfirmHandler} className={`text-white mt-20 md:mt-[50px] text-17 md:text-32 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo ${!loginAuth && 'font-preBold'}`}>{isPhnCnfrmd ? '다 음' : loginAuth ? '로그인' : '인증 확인'}</button> } </>}
        {!loginProcess && tab == 0 && !sentSms && <>
          <p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-50 md:mt-[90px]'>가입 권한 선택</p>
          <div className='flex flex-col justify-center items-center'>
            <div onClick={() => selectAuth('WOK')} className={`${auth === 'WOK' ? 'text-white bg-gradient-to-r from-gdFrom to-gdTo' : 'text-[#E05185] border-1 border-[#E05185]'} mt-30 flex justify-center items-center w-full py-30 md:py-50 text-23 leading-18 md:text-65 md:leading-45 outline-none rounded-[5px] md:rounded-[12px]`}>작업자</div>
            {/* 모바일 회원가입은 작업자만 허용 (현장대리인/주최사는 관리자 웹에서 가입) */}
            {/* <div onClick={() => selectAuth('SRV')} className={`${auth === 'SRV' ? 'text-white bg-gradient-to-r from-gdFrom to-gdTo' : 'text-[#E05185] border-1 border-[#E05185]'} mt-25 flex justify-center items-center w-full py-30 md:py-50 text-23 leading-18 md:text-65 md:leading-45 outline-none text-[#E05185] border-[#E05185] border-1 rounded-[5px] md:rounded-[12px]`}>현장대리인</div> */}
            {/* <div onClick={() => selectAuth('COM')} className={`${auth === 'COM' ? 'text-white bg-gradient-to-r from-gdFrom to-gdTo' : 'text-[#E05185] border-1 border-[#E05185]'} mt-25 flex justify-center items-center w-full py-30 md:py-50 text-23 leading-18 md:text-65 md:leading-45 outline-none text-[#E05185] border-[#E05185] border-1 rounded-[5px] md:rounded-[12px]`}>주최사</div> */}
          </div>
          {/* <p className='text-14 md:text-32 leading-[18px] md:leading-[45px] mt-20 md:mt-[40px] text-blue-500'>* 현장대리인은 명의도용 방지를 위해 실명인증이 필요합니다.</p> */}
        </>}
        {!loginProcess && tab == 0 && sentSms && <>
          <p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-50 md:mt-[90px]'>인증번호를 입력해주세요.</p>
          <p className='text-15 md:text-32 leading-[18px] md:leading-[45px] mt-10 md:mt-[25px] text-[#9C9C9B]'>{phoneNum}</p>
          <input value={authCode} onChange={(e) => setAuthCode(e.target.value)} className='mt-20 md:mt-[50px] w-full h-43 md:h-[107px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight placeholder:text-[#9C9C9B] placeholder:font-preLight' type='number' placeholder="(예) 1234"
                 maxLength={4} onInput={(e:any) => {e.target.value.length > e.target.maxLength && (e.target.value = e.target.value.slice(0, e.target.maxLength)); }}/>
          <button onClick={signUpPhoneConfirmHandler} className='text-white mt-20 md:mt-[50px] text-19 md:text-40 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo font-preBold'>인증 확인</button>
        </>}
        {tab === 1 &&<>
        <p className='text-18 leading-[18px] md:text-37 md:leading-[45px] mt-50 md:mt-[90px]'>{auth === REAL_NAME_AUTH ? '실명인증을 해주세요.' : '성함을 입력해주세요.'}</p>
        <input ref={userNmRef} value={userName} onChange={(e) => setUserName(e.target.value)} readOnly={auth === REAL_NAME_AUTH}
               placeholder={auth === REAL_NAME_AUTH ? '실명인증 후 자동으로 입력됩니다.' : ''}
               className={`${auth === REAL_NAME_AUTH ? 'bg-[#F5F5F5] ' : ''}mt-20 md:mt-[50px] w-full h-43 md:h-[107px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight placeholder:text-[#9C9C9B] placeholder:font-preLight`} type='text'/>
        {auth === REAL_NAME_AUTH && <>
        <div className='flex justify-between items-center mt-15 md:mt-[35px]'>
          <p className={`text-17 md:text-37 leading-[18px] md:leading-[45px] font-preLight ${realNameCnfrmd ? 'text-point' : 'text-[#9C9C9B]'}`}>{realNameCnfrmd ? '실명인증 완료' : '실명인증 미완료'}</p>
          <PccRequestForm ref={pccFormRef} onRequest={fn_requestPcc} disabled={realNameCnfrmd}
                          buttonLabel={realNameCnfrmd ? '인증 완료' : '실명인증'}
                          buttonClassName={`text-white text-17 md:text-32 leading-18 md:leading-36 w-full px-25 md:px-[60px] py-[0.5rem] md:py-[25px] outline-none rounded-[5px] md:rounded-[12px] ${realNameCnfrmd ? 'bg-[#B1B1B1]' : 'bg-gradient-to-r from-gdFrom to-gdTo'}`} />
        </div>
        <p className='text-14 md:text-32 leading-[18px] md:leading-[45px] mt-10 md:mt-[25px] text-blue-500'>* 현장대리인은 명의도용 방지를 위해 실명인증이 필요합니다.</p>
        <p className='text-14 md:text-32 leading-[18px] md:leading-[45px] text-blue-500'>* 가입하려는 휴대폰 번호와 동일한 본인 명의로 인증해주세요.</p>
        </>}
        {auth !== 'WOK' && <>
        <p className='text-18 leading-[18px] mt-24 md:text-37 md:leading-[45px] md:mt-[40px]'>비밀번호를 입력해주세요.</p>
        <input value={password} onChange={(e) => setPassword(e.target.value)} className='mt-20 md:mt-[50px] w-full h-47 md:h-[110px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight' type='password' />
        <p className='text-18 leading-[18px] mt-24 md:text-37 md:leading-[45px] md:mt-[40px]'>비밀번호를 다시 입력해주세요.</p>
        <input value={pwCheck} onChange={(e) => setPwCheck(e.target.value)} className='mt-20 md:mt-[50px] w-full h-47 md:h-[110px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight' type='password' />
        {password && <p className='text-15 leading-[18px] mt-10 md:text-37 md:leading-[45px] md:mt-[20px] text-point'>{pwCheck === '' ? '비밀번호 확인을 입력해주세요.' : password !== pwCheck ? '비밀번호가 일치하지 않습니다.' : ' '}</p> }
        </>}
        <button onClick={fn_nextTab} className={`${auth !== 'WOK' ? 'mt-40 md:mt-[80px]' : 'mt-40 md:mt-[70px]'} text-white text-19 md:text-40 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo`}>다 음</button>
        {/*placeholder:text-[#9C9C9B] placeholder:text-17 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25 placeholder:*/}
        {/*<p className='text-18 md:text-37 leading-[18px] md:leading-[45px] mt-20 md:mt-[40px]'>휴대폰 번호 <span className='text-point'>*</span></p>*/}
        {/*<div className='flex justify-between items-center'>*/}
        {/*  <input disabled={isPhnCnfrmd} ref={celPhnRef} value={phoneNum} onChange={(e) => setPhoneNum(e.target.value)} className={`${isPhnCnfrmd ? 'w-full' : 'w-[60%]'} mt-10 md:mt-[30px] py-[0.5rem] md:py-[30px] pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#a8a8a8] placeholder:text-[#9C9C9B] placeholder:text-17 placeholder:pl-5 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-15 md:placeholder:pb-25 placeholder:font-preLight`} type='number' placeholder="(예) 01012345678" />*/}
        {/*  {!isPhnCnfrmd && <button onClick={phoneCheckHandler} className='text-white mt-15 md:mt-[45px] font-preLight text-17 md:text-32 leading-18 md:leading-36 w-[35%] py-[0.5rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo'>인증하기</button> }*/}
        {/*</div>*/}
        </>}
        {tab === 2 &&<>
        <p className='text-18 leading-[18px] mt-30 md:text-37 md:leading-[45px] md:mt-[75px]'>개인정보 활용 동의</p> {/* <span className='text-point'>*</span> */}
          <OpenPersonalInfoCard circleCheck={circleCheck} personalInfoAllCheck={personalInfoAllCheck} personalInfoAllCancle={personalInfoAllCancle} check1={check1} check2={check2} check3={check3} setCheck1={setCheck1} setCheck2={setCheck2} setCheck3={setCheck3} setTerms1={setTerms1} setTerms2={setTerms2} setTerms3={setTerms3} />
          <button onClick={fn_nextTab} className='text-white mt-15 md:mt-[45px] font-preLight text-17 md:text-32 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo'>모든 약관에 동의합니다.</button></>}
        {tab === 3 &&<>
        <p className='text-18 leading-[18px] mt-30 md:text-37 md:leading-[45px] md:mt-[75px]'>전자서명</p> {/* <span className='text-point'>*</span> */}
        <div className='flex justify-between items-center mt-7 mb-7 md:mt-[30px] md:mb-[25px]'>
          <p className='font-preLight text-19 md:text-45 text-txtBlack'>사각형에 이름을 쓰세요.</p>
          <div onClick={clear} className='hover:cursor-pointer w-72 sm:w-92 md:w-[230px] bg-[#E4E4E4] flex items-center justify-center rounded-[5px] md:rounded-[12px] text-18 md:text-37 text-[#9C9C9B] font-preLight py-3 md:py-10'>다시 쓰기</div>
        </div>
        <div ref={mouseDownRef}>
          {tabMoving
            ? <img src={signature} alt="" className='w-full h-141 md:h-[352px] rounded-[5px] md:rounded-[12px] border border-[#D9D9D9]' />
            : <SignatureCanvas
              ref={signCanvas}
              canvasProps={{ className: `${exampleHide ? '' : `bg-[url('./images/signExample.png')]`} w-[255px] sm:w-[308px] md:w-[750px] h-141 md:h-[352px] border border-[#E4E4E4] rounded-[5px] md:rounded-[12px] z-[999]` }}
              backgroundColor="transparent"
              onEnd={saveSignature}
          />}
        </div>
          <button onClick={fn_nextTab} className='text-white mt-15 md:mt-[45px] font-preLight text-17 md:text-32 leading-18 md:leading-36 w-full py-[0.8rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo whitespace-pre'>필기한 전자서명이 효력이 있음을{'\n'}확인하였습니다.</button></>}
      </div>
    </div>
  );
}

// const SexBtn = ({ sex, setSex }: any) => {
//   return (
//     <div className='flex'>
//       <button onClick={() => setSex('male')} className={sex === 'male' ? 'border border-point text-point text-18 w-150 h-40 md:text-37 md:w-[222px] md:h-[80px] font-preLight' : `border border-[#c5c5c5] text-[#c5c5c5] text-18 w-150 h-40 md:text-37 md:w-[222px] md:h-[80px] font-preLight ${(sex == 'female') && 'border-r-0'}`}>남자</button>
//       <button onClick={() => setSex('female')} className={sex === 'female' ? 'border border-point text-point text-18 w-150 h-40 md:text-37 md:w-[222px] md:h-[80px] font-preLight' : 'border border-l-0 border-[#c5c5c5] text-[#c5c5c5] text-18 w-150 h-40 md:text-37 md:w-[222px] md:h-[80px] font-preLight'}>여자</button>
//     </div>
//   );
// };

// const [personalInfoCard, setPersonalInfoCard] = useState(false);
// const [isAll, setIsAll] = useState(false);
// const [pccReqinfo, setPccReqinfo] = useState("");
// const [pccReturl, setPccReturl] = useState("");
// const [pccVersion, setPccVersion] = useState("");

// useEffect(() => {
//   if (isAll && check1) {
//     setTerms2(true);
//   }
// }, [isAll, check1]);
//
// useEffect(() => {
//   if (isAll && check2) {
//     setTerms3(true);
//     setIsAll(false);
//   }
// }, [isAll, check2]);

// useEffect(() => {
//   envHelper.getEnv(function (data: any) {
//     setPccReqinfo(data.PCC_REQINFO)
//     setPccReturl(data.PCC_RETURL)
//     setPccVersion(data.PCC_VERSION)
//   })
// }, []);

// <form id="reqPCCForm" name="reqPCCForm" method="post" action="https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v2.jsp"
//       target="PCCV3Window" onSubmit={() => { return fn_requestPcc() }}>
//   <input type="hidden" name="reqInfo" defaultValue={pccReqinfo} />
//   <input type="hidden" name="retUrl" defaultValue={pccReturl} />
//   <input type="hidden" name="verSion" defaultValue={pccVersion} />
//   <button type="submit" className='text-white text-14 md:text-35 w-64 sm:w-84 md:w-[210px] h-40 md:h-[100px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] font-preLight' onClick={fn_requestPcc}>본인인증</button>
// </form>

// const fn_moveNext = async () => {
// if(birth === '') {
//   setSnackbarTxt('생년월일을 입력해 주십시오.');
//   return;
// }
// if (sex === '') {
//   setSnackbarTxt('성별을 선택해 주십시오.');
//   return;
// }
//
// if (!cfrmChk) {
//   setSnackbarTxt('전자서명 효력 여부를 확인해 주십시오.');
//   return;
// }
// setTab(2)
// }
// const fn_requestPcc = () => {
//   var popup = window.open('', 'PCCV3Window', 'width=400, height=630, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200');
//   if (popup == null) {
//     alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
//   }
//   return true
// }
// @ts-ignore
// window.___pcc_callback = function () {
//   envHelper.getPccValue(async function (r: any) {
//     console.log('rrr: ', r);
//     let rtrnData = await axios.post('admin/api/user/retrieveUserPhnDataCnt', { userPhonNum: r.phone });
//
//     if (rtrnData.data > 0) {
//       setSnackbarTxt('이미 등록된 휴대폰 번호 입니다.');
//     }
//     if (r.phone) {
//       setIsPhnCnfrmd(true);
//     }
//
//     setPhoneNum(r.phone)
//     setUserName(r.name)
//     if (r.sex === 'M') {
//       setSex('male')
//     } else {
//       setSex('female')
//     }
//   })
// }

// <p className='text-18 leading-[18px] mt-30 md:text-37 md:leading-[45px] md:mt-[75px]'>생년월일 <span className='text-point'>*</span></p>
// <input value={birth} onChange={(e) => setBirth(e.target.value)} className='mt-10 md:mt-[30px] w-full h-43 md:h-[107px] pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#a8a8a8] placeholder:text-[#9C9C9B] placeholder:text-17 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25 placeholder:font-preLight' type='number' placeholder="생년월일 8자리 입력 (예) 19850505"/>
// <div className='flex justify-center items-center mt-20 md:mt-[45px]'>
//   <p className='text-15 leading-[18px] md:text-37 md:leading-[45px]'>성별 <span className='text-point'>*</span></p>
//   <SexBtn sex={sex} setSex={setSex} />
// </div>
// {personalInfoCard
//     ? <ClosePersonalInfoCard circleCheck={circleCheck} personalInfoAllCheck={personalInfoAllCheck} personalInfoAllCancle={personalInfoAllCancle} setPersonalInfoCard={setPersonalInfoCard} />
//     : <div onClick={() => setSignatureCard(true)} className='flex items-center justify-center w-full h-142 md:h-[355px] rounded-[5px] md:rounded-[12px] border border-[#D9D9D9] text-20 md:text-37 text-[#C5C5C5] font-preLight mt-11 md:mt-[27px]'>이 사각형을 눌러 서명을 기입하세요.</div>}
// { !exampleHide && <div className='absolute text-[#CDCDCD] top-[15%] left-[15%] text-70 z-10'>홍 길 동</div> }
// <div className='flex items-center text-11 sm:text-14 md:text-32 text-[#9C9C9B] leading-[15px] md:leading-[37px] font-preLight mt-12 md:mt-[30px]'><input className='mr-10 md:mr-[25px] md:w-[40px] md:h-[40px] accent-point' type='checkbox' checked={cfrmChk} onChange={() => (setCfrmChk(!cfrmChk))} /><p onClick={() => (setCfrmChk(!cfrmChk))} className='underline underline-offset-1 decoration-[#B1B1B1] decoration-[0.5px]'>필기한 전자서명이 효력이 있음을 확인하였습니다.</p></div>
// <button onClick={fn_moveNext} className='text-white text-18 md:text-37 font-preLight w-[255px] sm:w-[308px] md:w-[750px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto px-10 py-10 mb-20 md:px-[25px] md:py-[25px] md:mb-[50px]'>다음</button>